<script>
    import {onMount, createEventDispatcher} from "svelte";
    import {navigate} from "svelte-routing";
    export let dates = [];

    let loaded = false;
    let slider = null;
    export let date;

    const dispatch = createEventDispatcher();

    $: console.log('Дата изменилась (console.log) на ' + date);
    $: (() => {
        console.log('Дата изменилась на ' + date)
        if (slider && date) {
            let activeIndex = 0;
            for (const index in dates) {
                if (dates[index] === date) {
                    activeIndex = index;
                    console.log('Нашли требуемый индекс', index, date);
                }
            }

            slider.slideTo(activeIndex);
        }
    });

    function changeDateHandler(date) {
        if (date) {
            navigate(`?date=${date}`);
        }
        dispatch('change', {date});
    }

    onMount(() => {
        loaded = true;

        let activeIndex = dates.length - 1;
        if (date) {
            for (const index in dates) {
                if (dates[index] === date) {
                    activeIndex = index;
                    console.log('Нашли требуемый индекс', index, date);
                }
            }
        }

        try {
            slider = new Swiper('#dates-control-slider', {
                slidesPerView: "auto",
                centeredSlides: true,
                slideActiveClass: 'active',
                slideToClickedSlide: true,
                loop: false,
                navigation: {
                    nextEl: ".next-btn",
                    prevEl: ".prev-btn",
                },
            });
            slider.slideTo(activeIndex);
            slider.on('slideChange', function () {
                date = dates[slider.realIndex];

                changeDateHandler(date);
            });
            window.dates_slider = slider;
        } catch (err) { console.error(err) }
    });
</script>

{#if dates && dates.length > 0}
<div>
    <span class="dates-title">Дата обновления:</span>
    <div class="dates-container">
        <div class="prev-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.75 15.5L10.9571 12.7071C10.5666 12.3166 10.5666 11.6834 10.9571 11.2929L13.75 8.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#74C733"/>
            </svg>
        </div>
        <div class="dates-block__slider-wrapper swiper" id="dates-control-slider">
            <div class="dates-block__wrapper swiper-wrapper">
                {#each dates as date}
                    <div class="dates-block__item swiper-slide">
                        <div class="dates-block__item-title">{date}</div>
                    </div>
                {/each}
            </div>
        </div>
        <div class="next-btn">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M10.75 8.5L13.5429 11.2929C13.9334 11.6834 13.9334 12.3166 13.5429 12.7071L10.75 15.5" stroke="black" stroke-linecap="round" stroke-linejoin="round"/>
                <rect x="0.5" y="0.5" width="23" height="23" rx="5.5" stroke="#74C733"/>
            </svg>
        </div>
    </div>
</div>
{/if}


<style>
    .dates-container {
        display: flex;
        align-items: center;
    }
    .dates-title {
        font-weight: 300;
    }
    .dates-block__item {
        padding: 8px 16px 6px;
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-align: center;
        -ms-flex-align: center;
        align-items: center;
        width: auto !important;
        -webkit-transition: all .2s ease;
        transition: all .2s ease;
        cursor: pointer;
    }

    .dates-block__item:not(.active) {
        color: #c6c5d2;
    }
    .prev-btn, .next-btn {
        display: flex;
    }
</style>